import React from 'react';
import { Autocomplete, Box, CircularProgress, IconButton, TextField, Typography, MenuItem, Select } from '@mui/material';
import { getStyles } from './styles';
import { useTheme } from '@mui/material/styles';
import { ChevronRight, ExpandMore, Folder, Refresh } from '@mui/icons-material';

function GoogleDrive({ loading, googledriveData, setGoogledriveData, fetchGoogleSubFolders, onReload }) {
    const theme = useTheme();
    const styles = getStyles(theme);
    const import_actions = ['New file is created in source folder', 'File is modified in source folder']

    const toggleFolderExpand = async (folder) => {
        if (folder.expanded) {
            setGoogledriveData(prev => ({
                ...prev,
                googledriveFolders: prev.googledriveFolders.filter(f => f.parentId !== folder.id)
            }));
            folder.expanded = false;
            return;
        }

        if (folder.hasChildren && !folder.childrenLoaded) {
            await fetchGoogleSubFolders(folder, googledriveData.accessToken);
        }

        folder.expanded = true;
        setGoogledriveData(prev => ({ ...prev, googledriveFolders: [...prev.googledriveFolders] }));
    };

    return (
        <Box>

            {googledriveData.errorStatus &&
                (<Typography sx={{ fontSize: '14px', fontWeight: '400', color: "#C30E2E" }}>
                    {googledriveData.errorMessage}
                </Typography>)
            }

            <Box sx={{ border: '1px solid #D9D9D9', borderRadius: '5px', padding: '15px', marginTop: '20px', width: '600px' }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Typography sx={{ fontSize: "15px", fontWeight: "600" }}>Import Source</Typography>
                    {!googledriveData.loading ?
                        (<IconButton onClick={() => onReload(googledriveData.googledriveConnector)}>
                            <Refresh />
                        </IconButton>)
                        :
                        (<CircularProgress size={'20px'} />)
                    }
                </Box>
                <Box mt={2}>
                    <Typography mb={1}>Import File(s) From <span style={{ color: 'red' }}>*</span></Typography>
                    <Autocomplete
                        size="small"
                        options={googledriveData.googledriveFolders || []}
                        value={googledriveData.googledriveSelectedFolders}
                        getOptionLabel={(option) => option.label}
                        renderInput={(params) => (
                            <TextField {...params} placeholder="Select Source Folder" />
                        )}
                        onChange={(e, newValue) =>
                            setGoogledriveData(prev => ({
                                ...prev,
                                googledriveSelectedFolders: newValue
                            }))
                        }
                        renderOption={(props, option) => (
                            <li {...props} style={{ paddingLeft: 8 + option.depth * 22 }}>
                                {option.hasChildren && (
                                    <span
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            toggleFolderExpand(option);
                                        }}
                                        style={{ cursor: 'pointer', marginRight: 6 }}
                                    >
                                        {option.expanded
                                            ? <ExpandMore fontSize="small" />
                                            : <ChevronRight fontSize="small" />
                                        }
                                    </span>
                                )}

                                <Folder fontSize="small" sx={{ mr: 1 }} />
                                <Typography sx={{ fontSize: 14 }}>
                                    {option.label}
                                </Typography>
                            </li>
                        )}
                    />
                    {googledriveData?.formErrors?.folderSelected && <Typography sx={{ ...styles.paraText, color: 'red' }}>{googledriveData?.formErrors?.folderSelected}</Typography>}
                </Box>
                <Typography marginTop={'10px'}>Only pdf, xls and doc files will be imported</Typography>
            </Box>

            <Box sx={{ border: '1px solid #D9D9D9', borderRadius: '5px', padding: '15px', marginTop: '20px', width: '600px' }}>
                <Typography sx={{ fontSize: "15px", fontWeight: "600" }}>Import Action</Typography>
                <Box mt={2}>
                    <Typography mb={1}>Import New File(s) When <span style={{ color: 'red' }}>*</span></Typography>
                    <Autocomplete
                        disabled={googledriveData.loading || loading}
                        size='small'
                        options={import_actions || []}
                        value={googledriveData.importAction}
                        getOptionLabel={(option) => option || ''}
                        renderInput={(params) => (<TextField {...params} placeholder="Select the import file" />)}
                        onChange={(e, newValue) => setGoogledriveData({ ...googledriveData, importAction: newValue })}
                        renderOption={(props, option) => (
                            <li {...props} style={{ paddingLeft: `${10 + (option?.depth || 0) * 22}px` }}>
                                <Typography sx={{ fontSize: '14px', fontWeight: '400' }}>{option}</Typography>
                            </li>
                        )}
                    />
                    {googledriveData?.formErrors?.import_action && <Typography sx={{ ...styles.paraText, color: 'red' }}>{googledriveData?.formErrors?.import_action}</Typography>}
                </Box>
                <Box mt={2}>
                    <Typography marginBottom={'4px'}>Check for Import Every <span style={{ color: 'red' }}>*</span></Typography>
                    <Select
                        size="small"
                        value={googledriveData.importInterval}
                        sx={{ width: '150px' }}
                        onChange={(e) => setGoogledriveData({ ...googledriveData, importInterval: e.target.value })}
                    >
                        <MenuItem value="one_minute">1 Minute</MenuItem>
                        <MenuItem value="five_minute">5 Minutes</MenuItem>
                        <MenuItem value="ten_minute">10 Minutes</MenuItem>
                        <MenuItem value="twenty_minute">20 Minutes</MenuItem>
                        <MenuItem value="thirty_minute">30 Minutes</MenuItem>
                    </Select>
                </Box>
            </Box>
        </Box >
    )
}

export default GoogleDrive;